import gql from 'graphql-tag';

export const CreateParticipantEmbeddableForm = gql`
  mutation CreateParticipantEmbeddableForm(
    $organizationId: ID!
    $participantId: ID!
    $request: CreateParticipantEmbeddableFormRequest!
  ) {
    createParticipantEmbeddableForm(
      organizationId: $organizationId
      participantId: $participantId
      request: $request
    ) {
      id
    }
  }
`;
